import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import { addPageData, navigateWizard } from '../../actions';
import QuestionPageLayout from '../../components/QuestionPageLayout';
import analytics from '../../lib/analytics';
import * as payloadFactory from '../../lib/pageDataPayloadFactory';
import { hasPreviousProdigyLoanSelector } from '../../reducers/selectors';

export const PreviousProdigyLoanPage = ({
  hasPreviousProdigyLoan: initialHasPreviousProdigyLoan,
  dispatchAddPageData,
  dispatchWizardNav,
}) => {
  const handleSubmit = hasPreviousProdigyLoan => {
    analytics.sendEvent('Click - Next', 'previous-prodigy-loan');

    const payload = payloadFactory.createAddPageDataPayload(
      'hasPreviousProdigyLoan',
      hasPreviousProdigyLoan,
    );
    dispatchAddPageData(payload);

    if (!hasPreviousProdigyLoan) {
      const clearPreviousProdigyLoanPayload = payloadFactory.createAddPageDataPayload(
        'previousProdigyLoan',
        { currency: '', loan: '' },
      );
      dispatchAddPageData(clearPreviousProdigyLoanPayload);
    }

    dispatchWizardNav({ dir: 'fwd' });
  };

  return (
    <QuestionPageLayout
      id="has-prodigy-loan"
      value={initialHasPreviousProdigyLoan}
      title="Do you have a previous Prodigy Finance Loan?"
      onSubmit={handleSubmit}
      helpText="If you've taken a loan from us to cover previous study periods, let us know."
    />
  );
};

PreviousProdigyLoanPage.propTypes = {
  hasPreviousProdigyLoan: PropTypes.bool,
  dispatchAddPageData: PropTypes.func.isRequired,
  dispatchWizardNav: PropTypes.func.isRequired,
};

PreviousProdigyLoanPage.defaultProps = {
  hasPreviousProdigyLoan: null,
};

export const mapStateToProps = state => ({
  hasPreviousProdigyLoan: hasPreviousProdigyLoanSelector(state),
});

export const mapDispatchToProps = {
  dispatchAddPageData: addPageData,
  dispatchWizardNav: navigateWizard,
};

export default connect(mapStateToProps, mapDispatchToProps)(PreviousProdigyLoanPage);
